import { Button, Modal, Spin } from "antd";
import { ModalCloseIcon } from "icons";
import styles from "./styles.module.scss";
import { useLanguageTranslator } from "hooks/use-language-translator";
import { ConditionalRenderer } from "components";

export const ConfirmationPopUp = ({
  open,
  onClose,
  onConfirm,
  title,
  description,
  Icon,
  loading = false,
  hideFooter,
}) => {
  const { translator } = useLanguageTranslator();
  return (
    <Modal
      destroyOnClose
      className={styles.logoutModal}
      closeIcon={<ModalCloseIcon />}
      title=""
      open={open}
      cancelText="No"
      centered={true}
      okText="Yes"
      width={792}
      footer={null}
      onCancel={onClose}
    >
      <Spin spinning={loading}>
        {Icon ? <Icon height={40} width={40} /> : null}

        <h1>{title}</h1>
        <p>{description}</p>
        <ConditionalRenderer condition={!hideFooter}>
          <div className={styles["modal-buttons"]}>
            <Button className={styles.modalNoButton} onClick={onClose}>
              {translator("no")}
            </Button>
            <Button
              className={styles.modalYesButton}
              type="primary"
              onClick={onConfirm}
            >
              {translator("yes")}
            </Button>
          </div>
        </ConditionalRenderer>
      </Spin>
    </Modal>
  );
};
